import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { NeuroMessage, useGuideConfig } from "@ignitesales/neuro-application";
import AppLoading from '../../AppLoading';
import UnsupportedBrowserModal from '../UnsupportedBrowserModal';
import getGuideId from "../../utils/getBranchId.mjs";

const LandingPage = ({ componentClass, onStartGuideClick, isLoadingNextPage }) => {
  const bemClass = 'landingPage';
  const classes = classnames(bemClass, componentClass);
  const { isBranchGuide, guideType } = useGuideConfig();
  const guideId = getGuideId({ isBranchGuide, guideType });
  const [ showBrowserModal, setShowBrowserModal ] = useState(false);
  const isIE = navigator?.userAgent?.match(/Trident/gi);
  const contentClasses = classnames(`${bemClass}__content`, {
    [`${bemClass}__content--branch`]: isBranchGuide,
    [`${bemClass}__content--online`]: !isBranchGuide,
  });

  useEffect(() => {
    if(!isBranchGuide) startGuide();
    if (isIE && (guideId == 170 || guideId == 173)) {
      setShowBrowserModal(true);
    }
  }, [isBranchGuide, guideId, isIE]);

  const startGuide = () => {
    onStartGuideClick('checking');
  };

  if (!isBranchGuide) { 
      return <AppLoading isLandingPage />;
  }

  return (
    <div className={classes}>
      <div className={`${bemClass}__imageMobile`}>
        <img src="/classpath/assets/images/landing-mobile.jpg" />
      </div>
      <div className={`${bemClass}__image`}>
        <img src="/classpath/assets/images/newLanding.jpg" />
      </div>

      <div className={contentClasses}>
        <div className="landingTextContainer">
          <NeuroMessage id="landing.title" tagName="h1" className="titleMessage" />
          <NeuroMessage id="landing.subtitle" className="subtitleMessage textConfig"/>
          <NeuroMessage id="landing.description1" className="descMessage textConfig"/>
          <NeuroMessage id="landing.description2" className="descMessage textConfig"/>
          <button onClick={startGuide} disabled={isLoadingNextPage} className={`btn btn-primary ${bemClass}__button`}>
            <NeuroMessage id="landing.getStarted" />
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <UnsupportedBrowserModal active={showBrowserModal} onClose={() => setShowBrowserModal(false)} />
    </div>
  );
};

export default LandingPage;
